import { LftSkeleton } from '@lift/design-system-react-web/dist/components';
import S from './skeleton.styles';

const Skeleton = () => {
  return (
    <S.SkeletonContainer data-testid="skeleton-container">
      <S.Titulo data-testid="skeleton-titulo">
        <LftSkeleton shape="line" />
      </S.Titulo>

      <S.Iframe data-testid="skeleton-iframe">
        <LftSkeleton shape="square" />
      </S.Iframe>
    </S.SkeletonContainer>
  );
};

export default Skeleton;
